import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { theme } from 'theme';

const ErrorMessage = ({ top, middle, bottom }: any) => {
  const classes = useStyles();
  return (
    <div className={classes.errorMessage}>
      <Typography variant="h3" component="div">
        {top}
      </Typography>
      <Typography variant="body1" component="div">
        {middle}
      </Typography>
      <Typography variant="body1" component="div">
        {bottom}
      </Typography>
    </div>
  );
};

export default ErrorMessage;

const useStyles = makeStyles(() => ({
  errorMessage: {
    alignSelf: 'center',
    textAlign: 'center',
    margin: '0 auto',
    '& *': {
      fontSize: '1.6rem'
    },
    '& div + div': {
      margin: theme.spacing(3)
    },
    '& a:hover': {
      cursor: 'pointer'
    }
  }
}));
